import styled from 'styled-components'
import { variant } from 'styled-system'

import Text from './Text'

const defaultValues = {
  fontSize: ['38px','42px', '48px'],
  fontFamily: 'Proxima',
  letterSpacing: ['-1.14px', '-1.26px', '-1.44px'],
  lineHeight: ['48px','50px', '56px'],
  fontWeight: 'black',
  textTransform: 'uppercase',
  wordBreak: 'break-word'
}

const H1 = styled(Text)(
  variant({
    variants: {
      default: {
        ...defaultValues
      },
      thin: {
        ...defaultValues,
        textTransform: 'none',
        lineHeight: '112%',
        fontWeight: 'normal'
      }
    }
  })
)

H1.defaultProps = {
  as: 'h1',
  variant: 'default'
}

export default H1
